import saveFile from "@cirrus/legacy/app-common/utils/saveFile.es6"

import { httpRequest, endpoint } from "@cirrus/core/http"

const FILE_STATUS_API = "/api/v1/author/results/export/ready"
const DOWNLOAD_API = "/api/v1/author/results/export/download"

export const checkExportFileStatus = async (params) =>
  await httpRequest.get(endpoint.withRoot(FILE_STATUS_API), {
    params: { sessionId: params.sessionId },
  })

export const downloadFile = async (url, fileName = "results.zip") => {
  /*const browser = Utils.getBrowserInfo()

  if (browser.name === "Safari") {
    return await downloadFileForSafari(url)
  }*/

  return await httpRequest
    .post(endpoint.withRoot(DOWNLOAD_API), { url }, { responseType: "arraybuffer" })
    .then((response) => {
      if (response.status === 204) {
        return
      }

      saveFile(response.data, {
        fileName,
      })
      return { fileName }
    })
}

const downloadFileForSafari = async (url) => {
  const form = $("<form></form>").attr("action", Url.token(DOWNLOAD_API)).attr("method", "post")

  form.append($("<input>").attr("type", "hidden").attr("name", "url").attr("value", url))
  form.appendTo("body").submit().remove()
  return new Promise((resolve) => {
    resolve()
  })
}
